export const CSS_CLASS_PREFIX = "tds";
export const CSS_ARMOR_CLASS = `${CSS_CLASS_PREFIX}a`;
